export default "__VITE_ASSET__BQpwQjGz__"